export default __webpack_public_path__ + "static/media/Icon-current-subscription-plan -new.20cf46c5.svg";